/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Action_Edit_Description_AfterInputs */

const fr_vehicle_action_edit_description_after = /** @type {(inputs: Vehicle_Action_Edit_Description_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` avant toute action.`)
};

const en_vehicle_action_edit_description_after = /** @type {(inputs: Vehicle_Action_Edit_Description_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` before taking any action.`)
};

/**
* | output |
* | --- |
* | "before taking any action." |
*
* @param {Vehicle_Action_Edit_Description_AfterInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_edit_description_after = /** @type {((inputs?: Vehicle_Action_Edit_Description_AfterInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_Edit_Description_AfterInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_edit_description_after(inputs)
	return en_vehicle_action_edit_description_after(inputs)
});